import { PropsWithChildren } from 'react'

import { useCreation } from 'ahooks'

import { HomeStoreContext } from './contexts/StoreContext'
import { createHomeStore } from './store/createStore'
import { HomeStoreUpdater } from './StoreUpdater'

export const HomeStoreProvider = ({ children }: PropsWithChildren) => {
  const store = useCreation(() => createHomeStore(), [])

  return (
    <HomeStoreContext value={store}>
      <HomeStoreUpdater />
      {children}
    </HomeStoreContext>
  )
}
